/* "New <type>" button + the Inject dialog it opens. */
import React, {
    useState
} from 'react';
import {
    FilePlus2
} from 'lucide-react';
import InjectDialog from './InjectDialog';
import type {
    DefType
} from '../api/types';

export default function NewDefButton({
    type,
    onCreated,
    label,
    secondary = false
}: {
    type: DefType;
    onCreated: (id: string) => void;
    label?: string;
    secondary?: boolean;
}) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button
                className={'aps-btn aps-btn-sm ' + (secondary ? 'aps-btn-secondary' : 'aps-btn-primary')}
                style={{
                    width: '100%'
                }}
                onClick={() => setOpen(true)}
            >
                <FilePlus2 size={14} />
                {label || `New ${type}`}
            </button>
            <InjectDialog
                type={type}
                open={open}
                onOpenChange={setOpen}
                onCreated={(id) => {
                    setOpen(false);
                    onCreated(id);
                }}
            />
        </>
    );
}
